import { render, staticRenderFns } from "./form-audit.vue?vue&type=template&id=6fa34a6b&scoped=true&"
import script from "./form-audit.vue?vue&type=script&lang=js&"
export * from "./form-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa34a6b",
  null
  
)

export default component.exports